import React from "react";

import Image from "next/image";

import Container from "components/Container";

import GearIcon from "assets/developers/gear-icon.png";
import GlobeIcon from "assets/developers/globe-icon.png";
import ListIcon from "assets/developers/list-icon.png";
import PersonCircleIcon from "assets/developers/person-circle-icon.png";
import UiIcon from "assets/developers/ui-icon.png";
import WideScreenIcon from "assets/developers/widescreen-icon.png";

import styles from "./EcoSystem.module.css";

const ITEMS = [
  {
    icon: GearIcon,
    title: "Powerful and familiar tooling",
    text: "Extensions are built with TypeScript, React and Node. Leverage npm's ecosystem to quickly build what you imagine.",
  },
  {
    icon: UiIcon,
    title: "No-brainer to build UI",
    text: "You concentrate on the logic, we push the pixels. Use our built-in UI components to be consistent with all our extensions.",
  },
  {
    icon: GlobeIcon,
    title: "Collaborate with our community",
    text: "Build your extension, share it with our community and get inspired by others.",
  },
  {
    icon: PersonCircleIcon,
    title: "A developer-first experience",
    text: "A strongly typed API, hot-reloading and modern tooling that make it a blast to work with.",
  },
  {
    icon: WideScreenIcon,
    title: "Easy to start, flexible to scale",
    text: "Start with a simple script, add a static UI or use React to go wild. Anything goes.",
  },
  {
    icon: ListIcon,
    title: "Publish to the world",
    text: "Submit your extension to the Raycast Store for thousands of Raycast users to use as part of their daily process.",
  },
];

const EcoSystem: React.FC = () => {
  return (
    <Container className={styles.container}>
      <h3 className={styles.h3}>Keeping our ecosystem beautiful</h3>

      <div className={styles.grid}>
        {ITEMS.map((item, index) => (
          <div className={styles.item} key={index}>
            <Image src={item.icon} width={48} height={48} layout="fixed" alt={item.title} />
            <h4>{item.title}</h4>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default EcoSystem;
